<div class="vendor-page">
  <div class="p-3 p-lg-4 vendor-shell">
    <div class="d-flex flex-column flex-xl-row justify-content-between gap-3 align-items-xl-center mb-3">
      <div class="d-flex align-items-center gap-3">
        <span class="title-badge">
          <lucide-icon [img]="Building2Icon" [size]="17"></lucide-icon>
        </span>
        <div>
          <div class="vendor-page-header__eyebrow">{{ isEdit() ? 'Vendor Management' : 'Vendor Onboarding' }}</div>
          <h1 class="page-title-lite">{{ isEdit() ? 'Edit Vendor' : 'Add New Vendor' }}</h1>
          <p class="vendor-page-subtitle mb-0">{{ isEdit() ? 'Update vendor profile, compliance documents, and users.' : 'Create a vendor profile with documents and access details.' }}</p>
        </div>
      </div>

      <div class="d-flex align-items-center gap-2 flex-wrap">
        <span class="status-pill text-capitalize vendor-status-badge" [class.approved]="isVendorApproved()" [class.pending]="!isVendorApproved()">
          {{ form.controls.status.value || 'pending' }}
        </span>
        <button class="btn btn-sm create-btn export" type="button" (click)="router.navigateByUrl('/vendors')">
          <lucide-icon [img]="ArrowLeftIcon" [size]="14"></lucide-icon><span class="ms-2">BACK</span>
        </button>
      </div>
    </div>

    <form [formGroup]="form" class="d-grid gap-3" (ngSubmit)="submit()">
      <div class="section-card">
        <div class="section-header">Basic Details</div>
        <div class="section-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Vendor Name *</label>
              <input class="form-control" formControlName="vendor_name" placeholder="Enter vendor name" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Vendor Type *</label>
              <select class="form-select" formControlName="vendor_type" (change)="onVendorTypeChange()">
                <option value="" disabled>Select type</option>
                @for (item of vendorTypeOptions; track item) { <option [value]="item">{{ item }}</option> }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">NOAR ID *</label>
              <input class="form-control" formControlName="noar_id" placeholder="Enter NOAR ID" />
              @if (noarIdDuplicateError()) {
                <div class="text-danger small mt-1">{{ noarIdDuplicateError() }}</div>
              }
            </div>
            <div class="col-md-6">
              <label class="form-label">Email *</label>
              <input class="form-control" type="email" formControlName="email" placeholder="Enter email address" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Contact Number</label>
              <input class="form-control" formControlName="contact_number" placeholder="Enter contact number" />
            </div>
            <div class="col-md-6">
              <label class="form-label">GST Number</label>
              <input class="form-control" formControlName="gst_number" placeholder="Enter GST number" />
            </div>
            <div class="col-md-6">
              <label class="form-label">PAN Number</label>
              <input class="form-control" formControlName="pan_number" placeholder="Enter PAN number" />
            </div>
            <div class="col-md-6">
              <label class="form-label">CIN</label>
              <input class="form-control" formControlName="cin" placeholder="Enter CIN" />
            </div>
          </div>
        </div>
      </div>

      @if (selectedVendorType() === 'Generator') {
        <div class="section-card">
          <div class="section-header">Generator Details</div>
          <div class="section-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Generator Type</label>
                <select class="form-select" formControlName="generator_type">
                  <option value="" disabled>Select type</option>
                  @for (item of generatorTypeOptions; track item) { <option [value]="item">{{ item }}</option> }
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Voltage Level</label>
                <select class="form-select" formControlName="voltage_level">
                  <option value="" disabled>Select voltage</option>
                  @for (item of voltageLevelOptions; track item) { <option [value]="item">{{ item }}</option> }
                </select>
              </div>
              <div class="col-md-6">
                <div class="form-field form-field--toggle">
                  <label class="form-label form-label--spacer" for="ctuConn">Connection</label>
                  <div class="vendor-toggle-card w-100">
                    <input class="form-check-input" type="checkbox" formControlName="connected_with_ctu" id="ctuConn" (change)="onCtuChange()" />
                    <label class="form-check-label ms-2" for="ctuConn">Connected with CTU</label>
                  </div>
                </div>
              </div>
              @if (!form.controls.connected_with_ctu.value) {
                <div class="col-md-6">
                  <label class="form-label">DISCOM</label>
                  <input class="form-control" formControlName="discom" placeholder="Enter DISCOM" />
                </div>
              }
            </div>
          </div>
        </div>
      }

      <div class="row g-3">
        <div class="col-lg-6">
          <div class="section-card h-100">
            <div class="section-header">Exchange Details</div>
            <div class="section-body">
              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label">Exchange Portfolio ID</label>
                  <input class="form-control" formControlName="exchange_portfolio_id" placeholder="Enter portfolio ID" />
                </div>
                <div class="col-12">
                  <div class="form-field form-field--toggle">
                    <label class="form-label form-label--spacer" for="exchangeReg">Registration</label>
                    <div class="vendor-toggle-card">
                      <input class="form-check-input" type="checkbox" formControlName="exchange_registered" id="exchangeReg" />
                      <label class="form-check-label ms-2" for="exchangeReg">Exchange Registered</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="section-card h-100">
            <div class="section-header">Location</div>
            <div class="section-body">
              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label">State</label>
                  <select class="form-select" formControlName="state" (change)="onStateChange()">
                    <option value="" disabled>Select state</option>
                    @for (item of stateOptions; track item) { <option [value]="item">{{ item }}</option> }
                  </select>
                </div>
                <div class="col-12">
                  <label class="form-label">Region</label>
                  <input class="form-control" formControlName="region" readonly placeholder="Auto-filled from state" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-header">Address</div>
        <div class="section-body">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Billing Address</label>
              <textarea class="form-control" rows="3" formControlName="billing_address" placeholder="Enter billing address"></textarea>
            </div>
            <div class="col-12">
              <label class="form-label">Registered Address</label>
              <textarea class="form-control" rows="3" formControlName="registered_address" placeholder="Enter registered address"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-header d-flex align-items-center gap-2">
          <lucide-icon [img]="FileTextIcon" [size]="16"></lucide-icon>
          <span>Document Detail</span>
        </div>
        <div class="section-body d-grid gap-3">
          @if (!selectedVendorType()) {
            <div class="alert alert-info py-2 mb-0">Select vendor type to load configured document list.</div>
          } @else if (requiredVendorConfigs().length === 0) {
            <div class="alert alert-warning py-2 mb-0">No active Vendor Module document configuration found for selected vendor type.</div>
          } @else {
            @if (!isEdit()) {
              <div class="alert alert-info py-2 mb-0">Selected files will upload when you submit the full vendor form.</div>
            }
            @if (missingMandatoryConfigs().length > 0) {
              <div class="alert alert-danger py-2 mb-0">
                Missing mandatory documents: {{ missingMandatoryConfigs().map(docTitle).join(', ') }}
              </div>
            }
            <div class="document-grid">
              @for (cfg of requiredVendorConfigs(); track cfg.id) {
                <div class="document-card">
                  <div class="document-card__top">
                    <label class="document-title">{{ docTitle(cfg) }} @if (isConfigMandatory(cfg)) { <span class="text-danger">*</span> }</label>
                    <span class="document-chip">{{ displayAllowedTypes(cfg) }}</span>
                  </div>
                  <input
                    class="form-control form-control-sm document-name-input"
                    [value]="displayDocName(cfg)"
                    placeholder="Click to select file"
                    readonly
                    (click)="triggerConfigFileInput(fileInput)"
                  />
                  <input
                    #fileInput
                    class="d-none"
                    type="file"
                    [accept]="acceptByConfig(cfg)"
                    (change)="onConfigFileSelected(cfg, $event)"
                  />
                  <div class="document-card__meta">Max {{ maxFileSizeMb(cfg) }} MB</div>
                  <div class="document-card__actions">
                    <button
                      class="btn btn-sm create-btn export document-action-btn"
                      type="button"
                      [disabled]="!canEditExistingVendor()"
                      (click)="triggerConfigFileInput(fileInput)"
                    >
                      {{ docForConfig(cfg) || pendingFile(cfg) ? 'Re-upload' : 'Upload' }}
                    </button>
                    <div class="d-flex align-items-center gap-2">
                      <button class="btn btn-light btn-sm module-icon-btn" type="button" [disabled]="!docForConfig(cfg) && !pendingFile(cfg)" (click)="viewConfigDocument(cfg)">
                        <lucide-icon [img]="EyeIcon" [size]="13"></lucide-icon>
                      </button>
                      <button class="btn btn-light btn-sm module-icon-btn module-icon-btn--danger" type="button" [disabled]="(!docForConfig(cfg) && !pendingFile(cfg)) || isDocumentLocked()" (click)="deleteConfigDocument(cfg)">
                        <lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon>
                      </button>
                    </div>
                  </div>
                  @if (pendingFile(cfg)) {
                    <div class="small text-primary mt-2">Selected for upload on submit</div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="section-card">
        <div class="section-header d-flex justify-content-between align-items-center gap-2">
          <div class="fw-semibold d-flex align-items-center gap-2">
            <lucide-icon [img]="UserIcon" [size]="16"></lucide-icon>
            <span>User Details</span>
          </div>
          <button class="btn btn-sm create-btn primary d-inline-flex align-items-center gap-1" type="button" [disabled]="!canEditExistingVendor()" (click)="openAddUser()">
            <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
            <span>ADD USER</span>
          </button>
        </div>

        <div class="section-body">
          <div class="table-responsive module-table-wrap">
            <table class="table table-sm align-middle mb-0 module-table user-table">
              <thead>
                <tr>
                  <th class="user-col-sr">S #</th>
                  <th>Name</th>
                  <th>User Name</th>
                  <th>Department</th>
                  <th>Designation</th>
                  <th>Email</th>
                  <th>Contact No.</th>
                  <th>Is Primary</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (users().length === 0) {
                  <tr>
                    <td colspan="9" class="text-center text-muted py-4 module-table-empty">No user added yet.</td>
                  </tr>
                }
                @for (user of users(); track user.id; let i = $index) {
                  <tr>
                    <td class="module-table__index">{{ i + 1 }}</td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.username }}</td>
                    <td>{{ user.department }}</td>
                    <td>{{ user.designation }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.contactNumber }}</td>
                    <td>{{ user.isPrimary ? 'Yes' : 'No' }}</td>
                    <td class="text-center">
                      <div class="module-table-actions">
                        <button class="btn btn-light btn-sm module-icon-btn" type="button" [disabled]="!canEditExistingVendor()" (click)="editUser(user)" title="Edit user">
                          <lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon>
                        </button>
                        <button class="btn btn-light btn-sm module-icon-btn" type="button" [disabled]="!canEditExistingVendor() || !isEdit()" (click)="openUserPrivileges(user)" title="Set privileges">
                          <lucide-icon [img]="ShieldCheckIcon" [size]="13"></lucide-icon>
                        </button>
                        <button class="btn btn-light btn-sm module-icon-btn module-icon-btn--danger" type="button" [disabled]="!canEditExistingVendor()" (click)="removeUser(user)" title="Delete user">
                          <lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="vendor-form-actions">
        <button class="btn btn-sm create-btn export" type="button" (click)="router.navigateByUrl('/vendors')">Cancel</button>
        @if (isEdit() && !isVendorApproved() && canEditExistingVendor()) {
          <button
            class="btn btn-sm create-btn approve"
            type="button"
            [disabled]="loading() || missingMandatoryConfigs().length > 0"
            (click)="approveVendor()"
          >
            Approve Vendor
          </button>
        }
        <button class="btn btn-sm create-btn primary" [disabled]="form.invalid || loading() || checkingNoarId() || !canEditExistingVendor() || isVendorSaveBlocked()">
          {{ loading() ? 'Saving...' : (isEdit() ? 'Update Vendor' : 'Add Vendor') }}
        </button>
      </div>
    </form>
  </div>
</div>

@if (showUserForm()) {
  <div class="user-modal-backdrop" (click)="closeUserForm()"></div>
  <div class="user-modal">
    <div class="user-modal-card">
    <div class="user-modal-header d-flex justify-content-between align-items-center gap-3">
      <div>
        <h6 class="mb-1">{{ editingUserId() ? 'Edit User' : 'Add User' }}</h6>
        <p class="mb-0">Manage vendor access and primary account ownership.</p>
      </div>
      <button class="btn btn-sm create-btn export" type="button" (click)="closeUserForm()">Close</button>
    </div>
    <div class="user-modal-body">
      <form [formGroup]="userForm" (ngSubmit)="saveUser()">
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label">Name *</label>
            <input class="form-control form-control-sm" formControlName="name" />
          </div>
          <div class="col-md-6">
            <label class="form-label">User Name *</label>
            <input class="form-control form-control-sm" formControlName="username" />
            @if (usernameDuplicateError()) {
              <div class="text-danger small mt-1">{{ usernameDuplicateError() }}</div>
            }
          </div>
          <div class="col-md-6">
            <label class="form-label">Department *</label>
            <input class="form-control form-control-sm" formControlName="department" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Designation *</label>
            <input class="form-control form-control-sm" formControlName="designation" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Email *</label>
            <input class="form-control form-control-sm" type="email" formControlName="email" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Contact No. *</label>
            <input class="form-control form-control-sm" formControlName="contactNumber" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Password {{ editingUserId() ? '' : '*' }}</label>
            <input
              class="form-control form-control-sm"
              type="password"
              formControlName="password"
              [placeholder]="editingUserId() ? 'Leave blank to keep current password' : 'Set login password'"
            />
          </div>
          <div class="col-12">
            <div class="form-check pt-1">
              <input class="form-check-input" id="userPrimaryCheck" type="checkbox" formControlName="isPrimary" />
              <label class="form-check-label" for="userPrimaryCheck">Is Primary User</label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 border-top mt-3 pt-3">
          <button class="btn btn-sm create-btn export" type="button" (click)="closeUserForm()">Cancel</button>
          <button class="btn btn-sm create-btn primary" type="submit" [disabled]="userForm.invalid || checkingUsername()">{{ editingUserId() ? 'Update User' : 'Add User' }}</button>
        </div>
      </form>
    </div>
    </div>
  </div>
}
